<!-- Batch Creation Component -->
<app-batch-creation
  [tenantId]="tenantId"
  [userId]="user.customClaims.principal_id"
  [areas]="areas"
  [deleteDocumentsEvent]="deleteDocumentsEventSubject.asObservable()"
  (cancelBatchCreationEvent)="cancelBatchCreation()"
  (hasUploadedFilesEvent)="hasUploadedFilesAtCreation = true"
  (finishBatchCreationEvent)="finishBatchCreation()"
></app-batch-creation>
